import moment from 'moment';
import _ from 'lodash';
import { CURRENCY_CODE } from '../data/currency_code';
import { MERCHANT_CATEGORY_CODE } from '../data/mcc';

export function getISODate() {
  const ISO = moment().format();

  return ISO;
}

export function toNum(val) {
  return Number(val);
}

export function toCents(val) {
  let res = Number.parseFloat(val);
  res = res * 100;
  res = Math.round(res)
  return res;
}

export function roundNumD(val) {
  let res = Math.round(val)
  return res
}

export function toBoolean(val) {
  if(val === 'true') {
      return true;
  } else if(val === 'false') {
      return false;
} else {
      return val
  }
}

const limit = (val, max) => {
  if (val.length === 1 && val[0] > max[0]) {
      val = '0' + val;
  }

  if (val.length === 2) {
      if (Number(val) === 0) {
          val = '01';
      } else if (val > max) {
          val = max;
      }
  }

  return val;
};

const monthsWithThirtyOneDays = [1, 3, 5, 7, 8, 10, 12];

const maxDaysForMonth = (month, year = 1999) => {
  if (Number(month) === 2) {
      const numYear = year === "" ? 1999 : Number(year);

      if (numYear % 1000 === 0) return '29';

      return (numYear % 4 === 0 && numYear % 100 !== 0) ? '29' : '28';
  }

  return monthsWithThirtyOneDays.includes(Number(month)) ? '31' : '30';
};

export const getFormatedExpDate = (val) => {
  let year = val.substring(2, 6);
  let month = limit(val.substring(0, 2), '12');
  let formatedDate = month + (year.length ? '\/' + year : '');

  return formatedDate;
};

export const getFormattedCredit = (val) => {
  let fc = '';
  let intervals = [4, 8, 12];

  _.forEach(val, (num, i) => {
      if (intervals.includes(i)) {
          fc += '-' + num;
      } else if (i === 16) {
          return fc;
      } else {
          fc += num;
      }
  });

  return fc;
}

export function getCurrencyOpt() {
  return _.map(CURRENCY_CODE, (val, key) => {
      return {
          'key': val,
          'text': val
      };
  });
}

export function getMCC() {
  return _.map(MERCHANT_CATEGORY_CODE, (val, key) => {
      return {
          'key': key,
          'text': `${key} ${_.truncate(val, {length: 45})}`
      };
  });
};

export function truncateStr(str, len) {
  if (typeof str === 'string') {
      if (str.length > 16) {
          return str.substr(0, len) + '...';
      }
  }

  return str;
};

export function cardIsValid(value) {
  // The Luhn Algorithm.
  if (/[^0-9-\s]+/.test(value)) {
      return false
  };
  let nCheck = 0;
  let bEven = false;
  value = value.replace(/\D/g, "");

  for (var n = value.length - 1; n >= 0; n--) {
      var cDigit = value.charAt(n),
          nDigit = parseInt(cDigit, 10);

      if (bEven && (nDigit *= 2) > 9) nDigit -= 9;

      nCheck += nDigit;
      bEven = !bEven;
  }

  let result = (nCheck % 10) === 0;
  return result;
};

export function zipCodeIsValid(value) {
  var zipCodePattern = /^\d{5}$|^\d{5}-\d{4}$/;
  return zipCodePattern.test(value);
};

export function CVVIsValid(value) {
  if (value.length && value.length === 3) {
      return true;
  } else {
      return false;
  }
};

export function expirationIsValid(value, format) {
  let current = moment();
  let exp = moment(value, format);

  if (typeof value !== 'string') {
      return false;
  } else if (current > exp) {
      return false;
  } else {
      return true;
  }
};

export function traverseData(dataObj) {
  if (!dataObj.hasOwnProperty('data')) {
    return dataObj;
  } else if (typeof dataObj === 'object' &&  dataObj.hasOwnProperty('data')) {
    return traverseData(dataObj.data);
  }
}